import { mutatorAction } from 'satcheljs';
import CortanaComposeViewState from '../store/schema/CortanaComposeViewState';
import DoradoRuntimeResult from '../store/schema/DoradoRuntimeResult';

export default mutatorAction('addFlexPaneResults', function addFlexPaneResults(
    viewState: CortanaComposeViewState,
    results: DoradoRuntimeResult[]
) {
    viewState.flexPaneResults = viewState.flexPaneResults.concat(results);
});
